
import { Routes, Route, useLocation } from "react-router-dom";
import menu from "../../hooks/menu.json";
import AplicacionesListado from "./listado";
import Aplicacion from "./aplicacion";
import DocumentMeta from "react-document-meta";

const Aplicaciones = () => {
    const { pathname } = useLocation();

    const findAppById = (m, id) => {
        for (let i = 0; i < m.length; i++) {
            if (m[i].id === id) {
                return m[i];
            }
            if (m[i].items) {
                let item = findAppById(m[i].items, id);
                if (item) return item;
            }
        }
    }

    const isApplication = (id) => {
        let app = findAppById(menu[1].items, id);
        console.log(app);
        return (app && !app.items);
    }

    return (
        <>
            <Routes>
                <Route path="">
                    <Route index={true} element={<AplicacionesListado />}></Route>
                    <Route path="/*" element={isApplication(pathname.split('/').pop()) ? <Aplicacion /> : <AplicacionesListado />}></Route>
                </Route>
            </Routes>
        </>
    );
}

export default Aplicaciones;